import { useMutation, useQuery } from "@tanstack/react-query";
import { environment } from "../../../../environment";
import { QUERY_KEYS } from "../../../../shared/enums/query-keys";
import { deleteObjects, getAccessList, getCalcStatuses, getConfigurationTypes, getHeatmapObjectStats, getModel, getModelInfo, getObjects, getObjectsDiagramsErrorQuery, getObjectsDiagramsStatsQuery, getPvSvMv, getRecalculation, getStatistic, getStatisticByType, getUIDataConfig, getValvePositionQuery, postCreateModel, postObjects, postValidateModel, putNewModel, putObjects, } from "./gateway-axios";
export function useStatistic(props) {
    return useQuery({
        queryKey: [QUERY_KEYS.Statistics, JSON.stringify(props)],
        queryFn: function () { return getStatistic(props); },
        enabled: Boolean(props.id),
    });
}
export function useConfigurationTypes() {
    return useQuery({
        queryKey: [QUERY_KEYS.ConfigurationTypes],
        queryFn: function () { return getConfigurationTypes(); },
    });
}
export function useStatisticByType(id) {
    return useQuery({
        queryKey: [QUERY_KEYS.StatisticByType, id],
        queryFn: function () { return getStatisticByType(id); },
    });
}
export function useGetCalcStatuses(id) {
    return useQuery({
        queryKey: [QUERY_KEYS.CalcStatuses, id],
        queryFn: function () { return getCalcStatuses(id); },
    });
}
export function useGetDiagramsObjectsError(payload, enabled) {
    if (enabled === void 0) { enabled = true; }
    return useQuery({
        queryKey: [QUERY_KEYS.ObjectsError, JSON.stringify(payload)],
        queryFn: function () { return getObjectsDiagramsErrorQuery(payload); },
        refetchInterval: environment.poolingInterval,
        enabled: enabled,
    });
}
export function useGetPvSvMv(payload, enabled) {
    if (enabled === void 0) { enabled = true; }
    return useQuery({
        queryKey: [QUERY_KEYS.PvMvSv, JSON.stringify(payload)],
        queryFn: function () { return getPvSvMv(payload); },
        refetchInterval: environment.poolingInterval,
        enabled: enabled,
    });
}
export function useGetValvePosition(payload, enabled) {
    if (enabled === void 0) { enabled = true; }
    return useQuery({
        queryKey: [QUERY_KEYS.ValvePosition, JSON.stringify(payload)],
        queryFn: function () { return getValvePositionQuery(payload); },
        refetchInterval: environment.poolingInterval,
        enabled: enabled,
    });
}
export function useGetModel(id) {
    return useQuery({
        queryKey: [QUERY_KEYS.Models, id],
        queryFn: function () { return getModel(id); },
    });
}
export function useGetModelLazy() {
    return useMutation({ mutationFn: getModel });
}
export function useGetModelInfo() {
    return useMutation({
        mutationFn: getModelInfo,
    });
}
export function useGetAccessList() {
    return useMutation({
        mutationFn: function () { return getAccessList(); },
    });
}
// TODO: попросить бэк переделать, чтобы для hitMapStatistic иерархия прилетала
// или хотя бы список всех объектов вплоть до выбранного вместе с подсчитанным средним
export function useGetDiagramsObjectsStats(payload, enabled) {
    if (enabled === void 0) { enabled = true; }
    // INFO: useQuery юзаем поскольку не мутируем данные (отправляется post-запрос)
    return useQuery({
        queryKey: [QUERY_KEYS.DiagramStats, JSON.stringify(payload)],
        queryFn: function () { return getObjectsDiagramsStatsQuery(payload); },
        refetchInterval: environment.poolingInterval,
        enabled: enabled,
    });
}
export function useGetHeatmapObjectStats(payload, enabled) {
    if (enabled === void 0) { enabled = true; }
    return useQuery({
        queryKey: [QUERY_KEYS.HeatmapStats, JSON.stringify(payload)],
        queryFn: function () { return getHeatmapObjectStats(payload); },
        refetchInterval: environment.poolingInterval,
        enabled: enabled,
    });
}
export function usePostValidateModel() {
    return useMutation({
        mutationFn: postValidateModel,
    });
}
export function usePostCreateModel() {
    return useMutation({
        mutationFn: postCreateModel,
    });
}
export function usePutNewModel() {
    return useMutation({
        mutationFn: putNewModel,
    });
}
export function useGetRecalculation() {
    return useMutation({ mutationFn: getRecalculation });
}
export function useUIDataConfigQuery(configName) {
    return useQuery({
        queryKey: [QUERY_KEYS.UIData, configName],
        queryFn: function () { return getUIDataConfig({ configName: configName }); },
        staleTime: Infinity,
        retry: false,
    });
}
export function useGetObjects() {
    return useQuery({
        queryKey: [QUERY_KEYS.Objects],
        queryFn: function () { return getObjects(); },
    });
}
export function usePostObjects() {
    return useMutation({
        mutationFn: function (object) { return postObjects(object); },
    });
}
export function usePutObjects() {
    return useMutation({
        mutationFn: function (object) { return putObjects(object); },
    });
}
export function useDeleteObjects() {
    return useMutation({
        mutationFn: function (id) { return deleteObjects(id); },
    });
}
